/**
 * 分类页接口优化需求：https://sayweee.atlassian.net/issues/PEP-7933
 * 如果商品数据存在show_remaining_count字段，以show_remaining_count为准
 * 否则使用之前的判断逻辑
 * @param data 商品数据
 * @returns
 */
export const getRemainingCount = data => {
  if ('show_remaining_count' in data) {
    return data.show_remaining_count ? data?.remaining_count ?? 0 : 0;
  }
  return data?.remaining_count > 0 && data?.remaining_count < 100 && data?.remaining_count < data?.one_day_sold_count
    ? data?.remaining_count
    : 0;
};

/**
 *
 * @param productId string
 * @param productKey string
 */
export const getUniqueProductId = (productId: number | string, productKey: string) => {
  if (productKey) {
    return productKey;
  }
  if (productId) {
    productKey = `${productId}`;
    return productKey;
  }
  console.log('getUniqueProductId error');
};

/**
 * 是否在商品名上访展示Tag标签
 * 可能展示的标签内容：
 * 1. 如果是餐馆菜，展示hotdish标签
 * 2. 如果是赞助商，展示赞助文案
 * 3. 如果有品牌名，展示品牌名
 */
export const canIShowTagAboveProductName = data => {
  return data?.is_hotdish === 'Y' || !!data?.brand_name || data?.sponsored_text;
};

/**
 * 商品名上方不展示额外的Tag标签时，商品名默认展示3行
 */
export const canIShow3LinesByTag = data => {
  return !canIShowTagAboveProductName(data);
};

export const getUniqueId2Qty = (userId: string, productId: string) => {
  return `${userId}-${productId}`;
};
